import state from './moduleMunicipalitieState.js'
import mutations from './moduleMunicipalitieMutations.js'
import actions from './moduleMunicipalitieActions.js'
import getters from './moduleMunicipalitieGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
